import { createFileRoute } from '@tanstack/react-router'
import { ViewEditContract } from '@/features/customers/components/contracts/ViewEditContract'

export const Route = createFileRoute(
  '/_auth/customers/$customerId/contracts/$contractId'
)({
  component: ContractDetailPage,
})

function ContractDetailPage() {
  const { customerId, contractId } = Route.useParams()

  return <ViewEditContract customerId={customerId} contractId={contractId} />
}
